type RowProps = {
  cssClasses?: string;
  id?: string;
  children?: React.ReactNode;
};

const Row: React.FC<RowProps> = ({ cssClasses = "w-full", id, children }) => {
  return (
    <div className={cssClasses} id={id ? id : ""}>
      {children}
    </div>
  );
};

export default Row;
